<!-- -->
<template>
    <page pageDataUrl="/api/pageData/page_p" v-on:paddingData="paddingPageData"
        :params="{type:  this.$route.params.type, key: this.$route.params.key, ckey: this.$route.params.ckey }"
        :hasbreadcrumbs="true" :breadcrumbs="breadcrumbs" :defPageTitle="p.pName">

        <div class='content'>
            <h1 class="entry-title">{{p.pName}}</h1>
            <div v-html="content">
            </div>
        </div>
    </page>
</template>

<script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';

    export default {
        //import引入的组件需要注入到对象中才能使用
        components: {},
        data() {
            //这里存放数据
            return {
                pg: {},
                p: {},
                content: "",
                breadcrumbs: []
            };
        },
        //监听属性 类似于data概念
        computed: {},
        //监控data中的数据变化
        watch: {},
        //方法集合
        methods: {
            paddingPageData(data) {
                this.pg = data.data.pg
                this.p = data.data.p
                this.content = data.data.content
                var bcs = []
                bcs.push({
                    path: '/units',
                    name: '产品介绍'
                })
                bcs.push({
                    path: '/units/' + this.pg.pGLink,
                    name: this.pg.pGName
                })
                if (data.data.fp !== undefined) {
                    bcs.push({
                        path: '/units/' + this.pg.pGLink + '/' + data.data.fp.pLink,
                        name: data.data.fp.pName
                    })
                }
                this.breadcrumbs = bcs
            }
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {

        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {
        },
        beforeCreate() { }, //生命周期 - 创建之前
        beforeMount() { }, //生命周期 - 挂载之前
        beforeUpdate() { }, //生命周期 - 更新之前
        updated() { }, //生命周期 - 更新之后
        beforeDestroy() { }, //生命周期 - 销毁之前
        destroyed() { }, //生命周期 - 销毁完成
        activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style  scoped>
    .content-info {
        padding: 0 15px;
    }

    .content-info h1 {
        font-weight: bold;
        font-size: 110%;
        text-align: left;
        margin-bottom: 10px;
    }

    .content-info p {
        text-align: left;
        font-size: 95%;
        line-height: 1.6;
    }
</style>